import React from "react";
import PaginatedTable from "../../components/table";
// import AddItem from "./components/addItem";
import { 
    // addPermissions, 
    getPermissions 
} from "./lib/roleData";
import { COLUMN_PERMISSIONS } from "./lib/constants";

const PermissionsIndex = () => {
    // const [pulse, setPulse] = useState(false);

    // const triggerUpdate = () => {
    //     setPulse(!pulse);
    // };

    return (
        <div>
            <h1>Permissions</h1>
            <PaginatedTable 
                getData={getPermissions} 
                columns={COLUMN_PERMISSIONS} 
                filterable={false} 
                sortable={false} 
                // updatePulse={pulse} 
            />
            {/* <br />
            <h2>Add New Role</h2>
            <AddItem addText="Add Role" addItem={addPermissions} triggerUpdate={triggerUpdate} /> */}
        </div>
    );
};

export default PermissionsIndex;
